//NOTE: Don't change these routes!!
export enum EligibilityRoutes {
  CompanyFold = "company-details",
  ApplicantFold = "applicant-details",
  ReceivablesFold = "receivables-details",
  EligibilityAmountFold = "eligibility-amount"
}

//all the routes in this application is defined here.
export const routes = {
  home: {
    new: "/home",
    initializeEligibility: "/home/initiateEligibilityFlow"
  },
  login: {
    new: "/login"
  },
  bills: {
    new: "/bills",
    upload: "/bills/upload"
  },
  gstinInactive: {
    new: "/gstin-inactive"
  },
  profile: {
    new: "/profile"
  },
  registration: {
    new: "/registration"
  },
  documents: {
    new: "/documents"
  },
  eligibility: {
    new: "/eligibility",
    config: "/eligibility/:fold",
    view: (fold: EligibilityRoutes) => `/eligibility/${fold}`,
    kyc: "/eligibility/kyc",
    bankAccountDetails: "/eligibility/bank-account-details"
  },
  reportIssue: {
    new: "/report-issue"
  },
  static:{
    tou: '/terms-of-use',
    pp:'/privacy-policy',
    bct:'/borrower-consent-terms'
  }
};
